export default "__VITE_ASSET__YkiUPuA0__"